import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../commons/ModalContainer";
import SimpleButton from "../commons/SimpleButton";
import SimpleAlert from "../popup/SimpleAlert";
import SimpleModal from "../popup/SimpleModal";
import SimpleDoc from "../SimpleDoc";

class SimpleUploadExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      data: [],
    };
  }

  changeInput = (fileName, file) => {
    if (file) {
      this.setState((prevValue) => ({ ...prevValue, data: file }));
    }
  };

  validateInput = async () => {
    const result = await this.props.onChange(this.state.data);
    const component = document.getElementById("inputFile");
    
    if(component && component.value){
      component.value = "";
    }
    if (!result) {
      this.showError();
      return;
    }
    this.props.onClickClose();
  };

  showError = () => {
    this.setState((prevValue) => ({ ...prevValue, error: !prevValue.error }));
  };

  render() {
    return (
      <>
        <SimpleModal
          title="Upload Part Detail Data"
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <div className="margin-5px">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>
                      Template file dapat diunduh
                    </h4>
                  </div>
                </div>
                <SimpleButton
                    text="DISINI"
                    onClick={this.props.onDownloadTemplate}
                    className="margin-top-5px"
                />
              </FlexView>

              <FlexView vAlignContent="center" className="margin-bottom-20px margin-top-20px">
                <SimpleDoc
                    readOnly
                    idInputFile="inputFile"
                    onChange={this.changeInput}
                />
              </FlexView>

              <FlexView hAlignContent="right" className="margin-bottom-20px margin-top-20px">
                <SimpleButton
                    styles={{ width: "250px" }}
                    onClick={this.validateInput}
                    disabled={this.state.data.length === 0}
                >
                  Validasi & Upload File
                </SimpleButton>
              </FlexView>
            </ModalContainer>
          }
        />
        {this.state.error && (
          <SimpleAlert
            title="Gagal Upload Data!"
            visible={this.state.error}
            onClickClose={this.showError}
            content="Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian."
            additionalButtons={
              <div style={{ display: "flex", alignItems: "center" }}>
                <SimpleButton secondary onClick={this.showError}>
                  Tutup
                </SimpleButton>
                {this.props.downloadError && <SimpleButton onClick={this.props.onDownloadLogError}>Download Error Log</SimpleButton>}
              </div>
            }
          />
        )}
      </>
    );
  }
}

export default SimpleUploadExcel;